module.exports = __webpack_public_path__ + "static/media/luislogo.29c76700.png";